import {JiraStore} from '@stores'
import {synchronizeStores} from '@stores/SynchronizeStores'

/// region Store

export class JiraUrlsStore {
  constructor(public store: JiraStore) {
    synchronizeStores(() => {

    })
  }

  confluence = {
    home: 'https://centric8.atlassian.net/wiki/spaces/VIP/pages'
  }

  jira = {
    home: 'https://centric8.atlassian.net/secure/Dashboard.jspa?selectPageId=14230#',
    myWork: 'https://centric8.atlassian.net/jira/your-work',
    vip: {
      activeSprints: 'https://centric8.atlassian.net/secure/RapidBoard.jspa?rapidView=192&projectKey=YFTS',
      backlog: 'https://centric8.atlassian.net/secure/RapidBoard.jspa?rapidView=192&projectKey=YFTS&view=planning&selectedIssue=YFTS-7944&quickFilter=866&issueLimit=100',

      sprint: {
        active: {
          openAndAssignedToMe: 'https://centric8.atlassian.net/secure/RapidBoard.jspa?rapidView=192&projectKey=YFTS&quickFilter=773&quickFilter=529',
          notClosed: 'https://centric8.atlassian.net/secure/RapidBoard.jspa?rapidView=192&projectKey=YFTS&quickFilter=866',
          readyForQa: 'https://centric8.atlassian.net/secure/RapidBoard.jspa?rapidView=192&projectKey=YFTS&quickFilter=1527',
          inProgress: 'https://centric8.atlassian.net/secure/RapidBoard.jspa?rapidView=192&config=quickFilters&quickFilter=1528',
          bugs: 'https://centric8.atlassian.net/secure/RapidBoard.jspa?rapidView=192&projectKey=YFTS&quickFilter=666',
          stories: 'https://centric8.atlassian.net/secure/RapidBoard.jspa?rapidView=192&projectKey=YFTS&quickFilter=667'
        }
      }
    }
  }
}

/// endregion




// WEBPACK FOOTER //
// ./src/stores/jira/JiraUrlsStore.ts